export const objectKeys = Object.keys as <T>(object: T) => (keyof typeof object)[];
